<template>
  <div class="panel-body">
    <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="#"> Inicio</a></li>
    <li class="breadcrumb-item active" aria-current="page">Cambio Contraseña</li>
  </ol>
</nav>
    <h1 class="regis">Cambio de Contraseña</h1>
    <hr class="my-4">
    <div class="contenidosdatosdoss poppins-normal-tuatara-14px">
      <p>La contraseña debe cumplir con las siguientes condiciones:</p>
      <div class="conetnidodess">
        <div class="chequeoo">
          <input class="form-check-input" type="checkbox" :checked="mini" onclick="return false;"  name="checkbox-1" >
          <div class="recordarr poppins-normal-tuatara-14px">Mínimo 8 Caracteres.</div>
        </div>
        <div class="chequeoo">
          <input class="form-check-input" type="checkbox" :checked="datomayus" onclick="return false;"  name="checkbox-1 ">
          <div class="recordarr poppins-normal-tuatara-14px">Mínimo 1 Mayúscula.</div>
        </div>
        <div class="chequeoo">
          <input class="form-check-input" type="checkbox" :checked="datominus" onclick="return false;"  name="checkbox-1" >
          <div class="recordarr poppins-normal-tuatara-14px">Mínimo 1 minuscula</div>
        </div>
        <div class="chequeoo">
          <input class="form-check-input" type="checkbox" :checked="datocarater" onclick="return false;"  name="checkbox-1" >
          <div class="recordarr poppins-normal-tuatara-14px">Mínimo 1 Carácter especial(@,_,#,&...)</div>
    
        </div>
        <div v-if="this.contraserepetida == true" class="ingrese-una-contraseasg poppins-normal-white-12px">Nueva Contraseña utilizada con anterioridad, digite otra contraseña. Recuerde que no debe emplear contraseñas que ha registrado en las 3 ocasiones anteriores.</div>
      </div>
                  
    </div>
    <div class="contenidosdatosas">
      <b-row>
        <b-col>
          <div class="correo-electrnico poppins-semi-bold-tuatara-14px">Contraseña Actual</div>
        </b-col>
        
        <b-col>
          <b-input-group>
          <b-form-input trim @input="validacionCodiciones()" :type="passwordzcc" v-model="antigua" class="campocc  emailllcc" placeholder="******" ></b-form-input>
            <b-input-group-append class="campoae  eye">
              <b-input-group-text @click="visualizarpasscc()">
                  <b-icon class="eyes2" v-if="passwordzcc == 'password' " icon="eye" />
                  <b-icon class="eyes2" v-if="passwordzcc == 'text' " icon="eye-slash" />
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col>
          <div class="correo-electrnico poppins-semi-bold-tuatara-14px">Nueva Contraseña</div>
        </b-col>
        <b-col>
          <div class="campo-con-error">
            <b-input-group>
              <b-form-input trim @input="validacionCodiciones()" :type="passwordz" v-model="newpassword" class="campocc emailllcc" placeholder="******"></b-form-input>
              <b-input-group-append class="campoae eye">
                <b-input-group-text @click="visualizarpass()">
                  <b-icon class="eyes2" v-if="passwordz == 'password'" icon="eye" />
                  <b-icon class="eyes2" v-if="passwordz == 'text'" icon="eye-slash" />
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <div v-if="notifi2" class="error-msg">{{ nocondiciones }}</div>
            <div v-if="notifi3" class="error-msg">{{ intentosContra }}</div>
          </div>
        </b-col>
      </b-row>  
      <b-row>
        <b-col>
          <div class="correo-electrnico poppins-semi-bold-tuatara-14px">Confirmar Contraseña</div>
        </b-col>
        <b-col>
          <div class="campo-con-error">
            <b-input-group>
              <b-form-input trim @input="validacionCodiciones()" v-model="confirpassword" :type="passwordd" class="campocc emailllcc" placeholder="******" :class="{ 'input-error': notifi }"></b-form-input>
              <b-input-group-append class="campoae eye">
                <b-input-group-text :class="{ 'append-error': notifi }" @click="visualizarpasss()">
                  <b-icon class="eyes2" v-if="passwordd == 'password'" icon="eye" />
                  <b-icon class="eyes2" v-if="passwordd == 'text'" icon="eye-slash" />
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <div v-if="notifi" class="error-msg">{{ nocoinciden }}</div>
          </div>
        </b-col>
      </b-row>

      <div @click="cambiarPassword()">
        <b-button block class="ingresarr"  ><span v-if="this.load == false ||this.notifi3 == true "  class="ingresar poppins-semi-bold-white-14px">Cambiar contraseña</span><div v-if="this.load == true && this.notifi3 == false " ><b-spinner small></b-spinner><span class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span></div></b-button></div>
      </div>
    <div>
      <b-alert class="alertared" :show="disiss" dismissible
      @dismissed="disiss=0"
      @dismiss-count-down="disissDownChanged" variant="danger">Digitar los campos faltantes.</b-alert>
      <b-alert class="alertared" :show="disiss" dismissible
      @dismissed="disiss=0"
      @dismiss-count-down="disissDownChanged" variant="danger">Contraseña anteriormente utilizada.</b-alert>
      <b-alert class="alertared" :show="disiss"
      dismissible
      @dismissed="disiss=0"
      @dismiss-count-down="disissDownChanged" variant="success">Contraseña actualizada exitosamente. </b-alert>  
      
  </div>
     <b-modal
              centered
              hide-footer
              no-close-on-backdrop
              no-close-on-esc
              hide-header
              v-model="bloqueo"
              title="Cambio Contraseña"
            >
            <ModalAcep :mensaje="mensaje" :ruta="ruta" :boton="boton" />

     </b-modal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../repositories/RepositoryFactory";
import Vue from 'vue'
import ModalAcep from "../components/ModalAcep.vue";
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";

Vue.use(VueFormGenerator)
const password = RepositoryFactory.get("recoverpass");
export default {
  components: {
        "vue-form-generator": VueFormGenerator.component,
        ModalAcep,
    },
    props: [
    "logo",
        "prmCielum",
        "passworde",
        "confirpasswordd",
        "children",,
        "laContraseaDebeC",
          "carateresocho",
        "caratermayus",
        "caraterminus",
        "caraterespecial",
        "nocondiciones",
        "nocoinciden",
        "tokenexpirado",
        "intentosContra"
    ],
  data () {
    return {
       mensaje: "La contraseña ha sido cambiada exitosamente.",
       ruta: "/inicio",
       boton: "Aceptar",
       bloqueo:false,
      notifi:false,
      notifi2:false,
      notifi3:false,
      mensaketoken:false,
      dismissSecs: 5,
        dismissCountDown: 0,
        disiss:0,
        dis:10,
        load:false,
        company:[],
        pp:"",
        datocarater: false,
        mini: false,
        datomayus:"",
        datominus:"",
        contraserepetida:"",
        antigua:"",
        newpassword: "",
        confirpassword: "",
        passwordzcc: "password",
        passwordz: "password",
        passwordd: "password",
        tokend: "",
      
     
    }
  },
  mounted(){
   
    
  },
  async created() {
    const correo = this.$route.params.myParam;
   
  
    try {
              const response = await password.cambioPassSesion({
                "email":correo,
              })
              this.tokend=response;

    }catch (error){}

    
 },
  methods: {
    async validacionContrasena() {
            if (this.newpassword != this.confirpassword) {
                this.notifi = true;
            } else {
                this.notifi = false;
            }
        },
        async cambiarPassword() {
          try {

            if(this.antigua == ""||this.newpassword == "" ||this.confirpassword == ""){
            this.disiss = this.dis;
            }else{
            if (this.newpassword != this.confirpassword) {
                this.notifi = true;
            } else {
                this.notifi = false;
                if (this.newpassword == "" || this.confirpassword == "" || this.datocarater == false || this.datominus == false || this.datomayus == false || this.mini == false) {
                    this.notifi2 = true;

                } else {
                    this.notifi2 = false;
                    if(this.acepto== false){
                        this.condiaceptoacepto = true
                    }else{
                      const token =localStorage.getItem('userToken');
                      this.load=true;

                      const response = await password.cambioPassword({
                        "password": this.newpassword,
                        "token": this.tokend,
                    }).then((respuesta) => {
                      
                      this.bloqueo = true;
                        
                    }).catch((error) => {
                    if(error.response.data.error.code == "TE400"){
                      this.notifi3=true;
                     // this.$router.push('/error401');
                    }
                   
                    });
                    }
                    
                }



            }
          }
          } catch (error) {
            if(error == "TE400"){
              this.$router.push('/error401');
            }
          }
          
        },
        async validacionCodiciones() {
            this.mayus = /[A-Z]/;
            this.datomayus = this.mayus.test(this.newpassword);
            this.minus = /[a-z]/;
            this.datominus = this.minus.test(this.newpassword);
            this.carater = /[;:\.,!¡\?¿@#\$%\^&\-_+=/>*<"\(\)\[\]\{\}]/;
            
            this.datocarater = this.carater.test(this.newpassword);
            if (this.newpassword.length >= 8) {
                this.mini = true;
                if (this.datomayus == true || this.datominus == true || this.datocarater == true) {


                } else {
                    this.datocarater = false;
                    this.datominus = false;
                    this.datomayus = false;


                }
            } else {
                this.mini = false;
            }

            // Validar coincidencia en tiempo real si confirpassword ya tiene contenido
            if (this.confirpassword !== '') {
                this.notifi = this.newpassword !== this.confirpassword;
            }
        },
        async validacion() {
            if (this.newpassword == "" || this.confirpassword == "" || this.datocarater == false || this.datominus == false || this.datomayus == false || this.mini == false) {
                this.notifi2 = true;
                // setTimeout(() => {
                //     this.$router.go('/CambioContrasea');
                // }, 4000);

            } else {
                this.notifi2 = false;
            }
        },
        async visualizarpasscc() {
            if (this.passwordzcc == "password") {
                this.passwordzcc = "text";
            } else {
                this.passwordzcc = "password";
            }
        },
        async visualizarpass() {
            if (this.passwordz == "password") {
                this.passwordz = "text";
            } else {
                this.passwordz = "password";
            }
        },
        async visualizarpasss() {
            if (this.passwordd == "password") {
                this.passwordd = "text";
            } else {
                this.passwordd = "password";
            }
        },
    validateName(value) {
      const regex = /^[a-zA-Z\s]*$/;
      if (!regex.test(value)) {
        this.model.pnombre = this.model.pnombre.replace(/[^a-zA-Z\s]/g, "");
      }
    },
    async remove(index){
      
      this.company= await this.eliminarElementoYInicializar(this.company,index)


    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      disissDownChanged(disiss) {
        this.disiss = disiss
      },
      
      eliminarElementoYInicializar(arr, indice) {
        arr.splice(indice, 1); // Elimina el elemento en el índice especificado

        const nuevoArr = []; // Crea un nuevo objeto vacío

        for (let i = 0; i < arr.length; i++) {
          nuevoArr[i] = arr[i]; // Asigna los elementos del arreglo con las nuevas llaves
        }


        return nuevoArr;
    },
   
    handleKeypress(event) {
                  if (this.identificationType == 'CC' | this.identificationType == 'TI' || this.identificationType == 'NI' || this.identificationType == 'NU') {

                if (e.key.match(/[0-9\s]/i) === null) {
                    e.preventDefault();
                }
            } else {
                if (e.key.match(/[a-z0-9\s]/i) === null) {
                    e.preventDefault();
                }
            }

        },
        
      },
}
</script>
<style>
/* ── Sección de condiciones (checkboxes) ── */
.contenidosdatosdoss {
  max-width: 440px;
  margin: 2% auto;
  text-align: left !important;
}

.conetnidodess {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
}

.chequeoo {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Sección del formulario ── */
.contenidosdatosas {
  max-width: 620px;
  margin: 0 auto;
  padding: 0 20px;
}

.contenidosdatosas .row {
  margin-bottom: 14px;
  align-items: flex-start;
}

.contenidosdatosas .correo-electrnico {
  padding-top: 8px;
}

/* ── Inputs y botón ojo ── */
.eyes2 {
  color: var(--blue-violet);
  cursor: pointer;
}

.campocc {
  height: 40px;
}

.campoae {
  margin-top: 0;
  height: 40px;
}

.emailllcc {
  border-bottom: 1px solid var(--hawkes-blue) !important;
  border-top: 1px solid var(--hawkes-blue) !important;
  border-left: 1px solid var(--hawkes-blue) !important;
  border-right: 1px solid white !important;
  border-radius: 0 !important;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

/* ── Mensajes de error ── */
.campo-con-error {
  display: flex;
  flex-direction: column;
}

.error-msg {
  display: block !important;
  visibility: visible !important;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #dc3545 !important;
  margin-top: 5px !important;
  width: 100%;
}

.input-error {
  border-top: 2px solid red !important;
  border-left: 2px solid red !important;
  border-bottom: 2px solid red !important;
}

.append-error {
  border-top: 2px solid red !important;
  border-right: 2px solid red !important;
  border-bottom: 2px solid red !important;
}

/* ── Botón principal ── */
.ingresarr {
  display: block;
  margin: 16px auto 20px auto;
  width: 52%;
  max-width: 300px;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 40px;
  border-color: transparent !important;
}
</style>